import request from "@/utils/request"

//获取期权账号信息
export function getOptionAccount(params) {
    return request({
        method: 'get',
        url: 'actual/option/assets/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}

//获取标的详细信息
export function getOptionSymbol(params) {
    return request({
        method: 'get',
        url: 'actual/option/symbol/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//获取标的收益曲线
export function getOptionSymbolEarnings(params) {
    return request({
        method: 'get',
        url: 'actual/option/earnings/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}
//获取标的期权持仓
export function getOptionSymbolPosition(params) {
    return request({
        method: 'get',
        url: 'actual/option/position/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}

//获取标的期权历史数据
export function getOptionSymbolHistory(params) {
    return request({
        method: 'get',
        url: 'actual/option/history/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}


// WEBPACK FOOTER //
// ./src/api/option.js